import { LanguageCode } from '@/shared/enums';
import { fetch } from '@/shared/fetch';

export const toggleLanguage = (languageCode: LanguageCode) =>
    fetch('/api/patients/language', 'POST', { LanguageCode: languageCode });
